/**
 * Route for `ipqs`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IpqsPage } from "../features/ipqs/IpqsPage";

export const ipqsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/ipqs",
	component: IpqsPage,
});

export default ipqsRoute;
